module.exports = __webpack_public_path__ + "img/minus-cirlce.0ad84df3.svg";